import http from './http'

export function getBonusClients(params = {}) {
  return http.get('bonus/list', { params }).then((res) => res.data)
}

export function getBonusSettings() {
  return http.get('settings/bonus').then((res) => res.data)
}

export function updateBonusSettings(data) {
  return http.post('settings', data).then((res) => res.data)
}
